import { createStyles } from "@mantine/emotion";

export const useStylesSubscriptionPage = createStyles((theme) => ({
  headerText: {
    fontSize: theme.spacing.subscription.fontSize.header,
    b: {
      fontWeight: "bolder",
    },
  },
  technicalTitle: {
    fontSize: theme.spacing.subscription.fontSize.title,
    lineHeight: theme.spacing.subscription.lineHeight.title,
    color: theme.customColors.blackLight,
    fontFamily: theme.headings.fontFamily.bold,
    marginTop: theme.spacing.subscription.margin.top.title,
    marginBottom: theme.spacing.subscription.margin.bottom.title,
  },
}));
